import ChangeMonthlyPaymentList from './pages/ChangeMonthlyPaymentList';

export const ChangeMonthlyPayment = [
  {
    path: '/atualizar-valor',
    exact: true,
    component: ChangeMonthlyPaymentList,
  },
];
